import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getClinicDentalServiceMasterByClinicId,
  updateClinicDentalServiceDetails,
  deleteClinicDentalServiceDetails,
  resetUpdateClinicDentalServiceDetailsMessage,
  resetDeleteClinicDentalServiceDetailMessage
} from "../../../store/slices/clinicDentalServiceMaster";
import classNames from "classnames";
import styles from "../clinicLabProfile/clinicLabProfile.module.scss";
import { RiProfileLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { Dropdown, Modal } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import UpdateDentalServiceDetails from "./UpdateDentalServiceDetails";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

const ClinicDentalTestMaster = () => {
  const serviceDetailsInitialState = {
    dentalId: "",
    dentalMasterId: "",
    serviceDetailName: "",
    pt_price: "",
    client_price: "",
    tax: "",
    status: "Active",
  };
  const [dentalServiceDetailsFormData, setDentalServiceDetailsFormData] = useState(serviceDetailsInitialState);
  const [editDentalServiceModal, setEditDentalServiceModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
 const clinicId =clinicInfo?.[0]?.clinicId;
  const dispatch = useDispatch();
  
  const {
    clinicDentalServiceMasterByClinicId,
    updateClinicDentalServiceDetailsSuccessMessage,
    updateClinicDentalServiceDetailsErrorMessage,
    deleteClinicDentalServiceDetailsSuccessMessage,
    deleteClinicDentalServiceDetailsErrorMessage,
  } = useSelector((state) => state.clinicDentalServiceMaster);

  const searchTimeout = useRef(null);

  useEffect(() => {
    dispatch(
      getClinicDentalServiceMasterByClinicId({
       clinicId,
        status: ["Active", "Inactive"],
        token
      })
    );
  }, [dispatch, userInfo, clinicId, token, deleteModal, editDentalServiceModal]);

  useEffect(() => {
    showTostifyMessageAndReset(updateClinicDentalServiceDetailsSuccessMessage, showToastifySuccess, resetUpdateClinicDentalServiceDetailsMessage);
    showTostifyMessageAndReset(updateClinicDentalServiceDetailsErrorMessage, showToastifyError, resetUpdateClinicDentalServiceDetailsMessage);
    showTostifyMessageAndReset(deleteClinicDentalServiceDetailsSuccessMessage, showToastifySuccess, resetDeleteClinicDentalServiceDetailMessage);
    showTostifyMessageAndReset(deleteClinicDentalServiceDetailsErrorMessage, showToastifyError, resetDeleteClinicDentalServiceDetailMessage);
  }, [
    updateClinicDentalServiceDetailsSuccessMessage,
    updateClinicDentalServiceDetailsErrorMessage,
    deleteClinicDentalServiceDetailsSuccessMessage,
    deleteClinicDentalServiceDetailsErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const handleChangeDentalServiceFormData = (event) => {
    setDentalServiceDetailsFormData({
      ...dentalServiceDetailsFormData,
      [event.target.name]: event.target.value,
    });
  };

  const handleEditDentalServiceDetails = (dentalServiceId, value) => {
    setEditDentalServiceModal(true);
    setDentalServiceDetailsFormData({
      dentalId: value?._id,
      clinicId: value?.clinicId?._id,
      dentalServiceId,
      dentalServiceName: value?.serviceDetailName,
      pt_price: value?.pt_price,
      client_price: value?.client_price,
      tax: value?.tax,
      status: value?.status,
    });
  };

  const handleSubmitUpdateDentalServiceDetails = async (event) => {
    event.preventDefault();
    try {
      await dispatch(updateClinicDentalServiceDetails({ ...dentalServiceDetailsFormData, token }));
      setEditDentalServiceModal(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteDentalServiceDetails = async (dentalMasterId, value) => {
    setDentalServiceDetailsFormData({
      dentalId: value?._id,
      dentalMasterId,
      dentalServiceName: value?.serviceDetailName,
    });
    setDeleteModal(true);
  };

  const handleConfirmDelete = async (e) => {
    try {
      await dispatch(
        deleteClinicDentalServiceDetails({
         clinicId,
          serviceId: dentalServiceDetailsFormData?.dentalId,
          dentalMasterId: dentalServiceDetailsFormData?.dentalMasterId,
          token,
        })
      );
      setDeleteModal(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (searchTimeout.current){
      setTimeout(searchTimeout.current)
    }
    searchTimeout.current = setTimeout(() => {
      if (value.trim()) {
        dispatch(
          getClinicDentalServiceMasterByClinicId({
            clinicId,
            searchQuery: value,
            status: ["Active", "Inactive"],
            token,
          })
        )
      } else {
        dispatch(
          getClinicDentalServiceMasterByClinicId({
            clinicId,
            status: ["Active", "Inactive"],
            token,        
          })
        );
      }
    }, 300);
  };

  return (
    <>
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        <div className="input-group search-area ms-auto d-inline-flex me-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search here"
            value={searchValue}
            onChange={handleSearch}
          />
          <div className="input-group-append">
            <button type="button" className="input-group-text">
              <FaSearch className="flaticon-381-search-2" />
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        {clinicDentalServiceMasterByClinicId?.length > 0 &&
          clinicDentalServiceMasterByClinicId[0]?.services?.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-sm-1" key={index}>
              <div className="card project-boxed">
                <div
                  className={classNames(
                    styles.titel,
                    "card-header",
                    "align-items-start"
                  )}
                >
                  <div className={styles.titelWrapper}>
                    <RiProfileLine />
                    <h6 className="fs-18 font-w500">
                      <Link to={"#"} className="text-black user-name">
                        {item?.serviceDetailName}
                      </Link>
                    </h6>
                  </div>
                  <Dropdown className="">
                    <Dropdown.Toggle
                      variant=""
                      as="div"
                      className="btn-link i-false"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{}}
                      >
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align={"end"}>
                      <Dropdown.Item
                        onClick={() => handleEditDentalServiceDetails(clinicDentalServiceMasterByClinicId[0]?._id, item)}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => handleDeleteDentalServiceDetails(clinicDentalServiceMasterByClinicId[0]?._id, item)}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="card-body p-0 pb-3">
                  <ul className="list-group list-group-flush">
                    <li className={classNames(styles.list, "list-group-item")}>
                      <b className={styles.clinicName}>Service Name:</b>
                      <span className="text-black ms-2">{item?.serviceDetailName}</span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <b className={styles.clinicName}>Client Price:</b>
                      <span className="text-black ms-2">
                        {item?.client_price || "N/A"}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <b className={styles.clinicName}>Pateint Price:</b>
                      <span className="text-black ms-2">
                        {item?.pt_price || "N/A"}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <b className={styles.clinicName}>Tax:</b>
                      <span className="text-black ms-2">
                        {item?.tax || "N/A"}
                      </span>
                    </li>
                    <li className={classNames(styles.list, "list-group-item")}>
                      <b className={styles.clinicName}>Status:</b>
                      <span className="text-black ms-2">
                        {item?.status || "N/A"}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
      </div>
      <UpdateDentalServiceDetails
        editDentalServiceModal={editDentalServiceModal}
        setEditDentalServiceModal={setEditDentalServiceModal}
        dentalServiceDetailsFormData={dentalServiceDetailsFormData}
        handleSubmitUpdateDentalServiceDetails={handleSubmitUpdateDentalServiceDetails}
        handleChangeDentalServiceFormData={handleChangeDentalServiceFormData}
      />
      <Modal
        centered
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        size={"md"}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Confirm Delete
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to delete {" "}
            <strong className="text-dark">
              {dentalServiceDetailsFormData?.dentalServiceName}
            </strong> {" "}
            service ?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModal(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleConfirmDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ClinicDentalTestMaster;
